/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import firebase from 'firebase/compat/app';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { SiCashapp } from 'react-icons/si';
import { db } from '../config/firebaseConfig';
import { UserAuth } from '../context/authContext';
import CreateTranscation from './CreateTranscation';
import CopyComponent from './utils/CopyComponent';

const formatAddress = (address) => {
  if (!address) return '';
  return `${address.substring(0, 10)}...${address.substring(
    address.length - 8
  )}`;
};

const CreateTransaction = () => {
  const { userData, user } = UserAuth();
  const [roomId, setRoomId] = useState(localStorage.getItem('roomId') || '');
  const [datax, setDatax] = useState('');
  const [role, setRole] = useState(() => localStorage.getItem('role') || '');
  const [createdBy, setCreatedBy] = useState([]);

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe = db
      .collection('rooms')
      .doc(roomId)
      .onSnapshot(
        (roomSnapshot) => {
          if (roomSnapshot.exists) {
            const data = roomSnapshot.data();
            setDatax(data);
            setCreatedBy(data.createdBy || []);
          } else {
            localStorage.removeItem('roomId');
            window.location.reload();
          }
        },
        (error) => {
          console.error('Error fetching room details:', error);
          toast.error('Error fetching room details.');
        }
      );

    return () => unsubscribe();
  }, [roomId]);

  const handleLeaveRoom = async () => {
    try {
      await db
        .collection('rooms')
        .doc(roomId)
        .update({
          [`${role === 'validator' ? 'miners' : 'participants'}`]:
            firebase.firestore.FieldValue.arrayRemove(userData.publicKey),
        });
      localStorage.removeItem('roomId');
      localStorage.removeItem('role');
      toast.success('You have left the room successfully.');
      window.location.href = '/';
      setRoomId('');
      setRole('');
    } catch (error) {
      console.error('Error leaving room:', error);
      toast.error('Failed to leave room. Please try again later.');
    }
  };

  const handleEndRoom = async () => {
    if (roomId && user.email) {
      try {
        const roomDocRef = db.collection('rooms').doc(roomId);
        const subcollectionNames = ['blocks', 'transactions'];

        await Promise.all(
          subcollectionNames.map(async (subcollectionName) => {
            const subcollectionRef = roomDocRef.collection(subcollectionName);
            const docs = await subcollectionRef.get();
            docs.forEach(async (doc) => {
              await doc.ref.delete();
            });
          })
        );

        await roomDocRef.delete();
        toast.success('Room ended successfully.');
        window.location.href = '/';

        setRoomId('');
        localStorage.removeItem('roomId');
      } catch (error) {
        console.error('Error ending room:', error);
        toast.error('Failed to end room. Please try again later.');
      }
    } else {
      toast.error('Cannot end room: Room ID or user information is missing.');
    }
  };

  return (
    <section className="min-h-screen pt-10 pb-12 px-6">
      <div className="max-w-7xl mx-auto text-white">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white tracking-tight">
              Create Transaction
            </h1>
            <p className="text-white/40 mt-1">
              Manage room details and initiate transactions
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Top Row: Room Info & Create Transaction */}

          {/* Left Card - Room Information */}
          <div className="bg-[#0f111a]/60 backdrop-blur-xl rounded-2xl p-6 border border-white/5 flex flex-col h-full">
            <div className="flex items-center gap-4 mb-6 pb-6 border-b border-white/5 bg-white/[0.02] -mx-6 px-6 pt-2">
              <div className="w-12 h-12 rounded-xl bg-purple-500/10 flex items-center justify-center border border-purple-500/10">
                <SiCashapp />
              </div>
              <div>
                <h3 className="text-white font-semibold text-lg">
                  Your Wallet
                </h3>
                <p className="text-purple-400 font-mono font-medium">
                  {userData?.balance?.toFixed(2) || '0.00'}
                </p>
              </div>
            </div>

            <div className="space-y-5 flex-1">
              <div className="group">
                <label className="text-white/40 text-xs font-medium uppercase tracking-wider mb-2 block group-hover:text-white/60 transition-colors">
                  Room ID
                </label>
                <div className="flex items-center gap-2 bg-black/20 hover:bg-black/30 border border-white/5 hover:border-white/10 rounded-xl px-4 py-3 transition-all">
                  {/* <input
                    type="text"
                    readOnly
                    className="flex-1 bg-transparent text-white/80 text-sm font-mono outline-none truncate"
                    value={roomId || ''}
                  /> */}
                  <CopyComponent data={roomId || ''} />
                </div>
              </div>

              <div className="group">
                <label className="text-white/40 text-xs font-medium uppercase tracking-wider mb-2 block group-hover:text-white/60 transition-colors">
                  Public Key
                </label>
                <div className="flex items-center gap-2 bg-black/20 hover:bg-black/30 border border-white/5 hover:border-white/10 rounded-xl px-4 py-3 transition-all">
                  {/* <input
                    type="text"
                    readOnly
                    className="flex-1 bg-transparent text-white/80 text-sm font-mono outline-none truncate"
                    value={userData?.publicKey || ''}
                  /> */}
                  <CopyComponent data={userData?.publicKey || ''} />
                </div>
              </div>

              <div className="group">
                <label className="text-white/40 text-xs font-medium uppercase tracking-wider mb-2 block group-hover:text-white/60 transition-colors">
                  Private Key
                </label>
                <div className="flex items-center gap-2 bg-black/20 hover:bg-black/30 border border-white/5 hover:border-white/10 rounded-xl px-4 py-3 transition-all">
                  {/* <input
                    type="password" 
                    readOnly
                    className="flex-1 bg-transparent text-white/80 text-sm font-mono outline-none"
                    value={userData?.privateKey || ''}
                  /> */}
                  <CopyComponent data={userData?.privateKey || ''} />
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-white/5">
              {createdBy === user.email ? (
                <button
                  onClick={handleEndRoom}
                  type="button"
                  className="w-full px-6 py-3.5 bg-red-500/10 hover:bg-red-500/20 text-red-500 border border-red-500/20 hover:border-red-500/30 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                  End Session
                </button>
              ) : (
                <button
                  onClick={handleLeaveRoom}
                  type="button"
                  className="w-full px-6 py-3.5 bg-white/5 hover:bg-white/10 text-white border border-white/10 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  Leave Room
                </button>
              )}
            </div>
          </div>

          {/* Right Card - Create Transaction */}
          <div className="bg-[#0f111a]/60 backdrop-blur-xl rounded-2xl p-6 border border-white/5 flex flex-col h-full">
            <div className="flex items-center gap-4 mb-6 pb-6 border-b border-white/5 bg-white/[0.02] -mx-6 px-6 pt-2">
              <div className="w-12 h-12 rounded-xl bg-green-500/10 flex items-center justify-center border border-green-500/10">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="text-green-400"
                >
                  <path d="M12 5v14M5 12h14" />
                </svg>
              </div>
              <div>
                <h3 className="text-white font-semibold text-lg">
                  New Transaction
                </h3>
                <p className="text-white/40 text-sm">Send funds securely</p>
              </div>
            </div>

            <div className="flex-1">
              <CreateTranscation
                user={user}
                userData={userData}
                roomId={roomId}
              />
            </div>
          </div>

          {/* Bottom Row: Participants & Validators */}

          {/* List of Participants */}
          <ListofParticipant roomId={roomId} />

          {/* List of Validators */}
          <ListMiner roomId={roomId} />
        </div>
      </div>
    </section>
  );
};

export default CreateTransaction;

const ListofParticipant = ({ roomId }) => {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    if (!roomId) return;
    const unsubscribe = db
      .collection('rooms')
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData = doc.data();
          if (roomData.participants?.length > 0) {
            const users = await getDocs(
              query(
                collection(db, 'users'),
                where('publicKey', 'in', roomData.participants)
              )
            );
            setParticipants(users.docs.map((v) => v.data()));
          } else {
            setParticipants([]);
          }
        }
      });
    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="bg-[#0f111a]/60 backdrop-blur-xl rounded-2xl border border-white/5 overflow-hidden flex flex-col h-full">
      <div className="p-6 border-b border-white/5 flex items-center justify-between bg-white/[0.02]">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-500/10 rounded-lg text-blue-400 border border-blue-500/10">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div>
            <h4 className="text-white font-semibold text-lg leading-tight">
              Participants
            </h4>
            <p className="text-white/30 text-xs">Active in room</p>
          </div>
        </div>
        <div className="px-2.5 py-0.5 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs font-mono">
          {participants.length}
        </div>
      </div>

      <div className="p-4 space-y-2">
        {participants.length === 0 ? (
          <div className="text-center py-8 text-white/30 text-sm">
            No participants
          </div>
        ) : (
          participants.map((participant, index) => (
            <div
              key={index}
              className="group flex items-center justify-between p-3 rounded-xl bg-white/[0.03] hover:bg-white/[0.08] hover:scale-[1.01] border border-transparent hover:border-white/10 transition-all duration-200"
            >
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <div className="relative">
                  <img
                    src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${participant.email}`}
                    alt="avatar"
                    className="w-9 h-9 rounded-full bg-white/5 ring-2 ring-white/5"
                  />
                  <div className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2 border-[#13151b]"></div>
                </div>

                <div className="min-w-0 flex-1">
                  <p className="text-white/90 font-medium text-sm truncate mb-0.5">
                    {participant.email}
                  </p>
                  <p
                    className="text-white/30 text-xs font-mono truncate tracking-wide hover:text-white/70 transition-colors cursor-pointer"
                    title={participant.publicKey}
                  >
                    {formatAddress(participant.publicKey)}
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(participant.publicKey);
                  toast.success('Copied Successfully');
                }}
                className="ml-2 p-1.5 rounded-lg bg-purple-500/30 hover:bg-purple-500/50 text-purple-300 hover:text-purple-200 transition-all"
                title="Copy public key"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M7 4V2H17V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"></path>
                </svg>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const ListMiner = ({ roomId }) => {
  const [miners, setMiners] = useState([]);

  useEffect(() => {
    if (!roomId) return;
    const unsubscribe = db
      .collection('rooms')
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData = doc.data();
          if (roomData.miners?.length > 0) {
            const users = await getDocs(
              query(
                collection(db, 'users'),
                where('publicKey', 'in', roomData.miners)
              )
            );
            setMiners(users.docs.map((v) => v.data()));
          } else {
            setMiners([]);
          }
        }
      });
    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="bg-[#0f111a]/60 backdrop-blur-xl rounded-2xl border border-white/5 overflow-hidden flex flex-col h-full">
      <div className="p-6 border-b border-white/5 flex items-center justify-between bg-white/[0.02]">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-amber-500/10 rounded-lg text-amber-400 border border-amber-500/10">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
              <path d="M12 12v.01"></path>
            </svg>
          </div>
          <div>
            <h4 className="text-white font-semibold text-lg leading-tight">
              Validators
            </h4>
            <p className="text-white/30 text-xs">Active validators</p>
          </div>
        </div>
        <div className="px-2.5 py-0.5 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs font-mono">
          {miners.length}
        </div>
      </div>

      <div className="p-4 space-y-2">
        {miners.length === 0 ? (
          <div className="text-center py-8 text-white/30 text-sm">
            No validators assigned
          </div>
        ) : (
          miners.map((participant, index) => (
            <div
              key={index}
              className="group flex items-center justify-between p-3 rounded-xl bg-amber-500/[0.03] hover:bg-amber-500/[0.08] hover:scale-[1.01] border border-transparent hover:border-amber-500/20 transition-all duration-200"
            >
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <div className="relative">
                  <img
                    src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${participant.email}`}
                    alt="avatar"
                    className="w-9 h-9 rounded-full bg-white/5 ring-2 ring-amber-500/20"
                  />
                  <div className="absolute -bottom-1 -right-1 bg-amber-500 rounded-full p-0.5 border-2 border-[#13151b]">
                    <svg
                      width="8"
                      height="8"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      className="text-[#13151b]"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                  </div>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-white/90 font-medium text-sm truncate mb-0.5 group-hover:text-amber-400 transition-colors">
                    {participant.email}
                  </p>
                  <p
                    className="text-amber-500/50 text-xs font-mono truncate tracking-wide hover:text-amber-400/70 transition-colors cursor-pointer"
                    title={participant.publicKey}
                  >
                    {formatAddress(participant.publicKey)}
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(participant.publicKey);
                  toast.success('Copied Successfully');
                }}
                className="ml-2 p-1.5 rounded-lg bg-amber-500/30 hover:bg-amber-500/50 text-amber-300 hover:text-amber-200 transition-all"
                title="Copy public key"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M7 4V2H17V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"></path>
                </svg>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
